export default __webpack_public_path__ + "static/media/donutLegendDown.fd4e1ef8.svg";